import React, { Fragment } from "react";

import Hero from "./Hero";
import Jobs from "./Jobs";
import Resume from "./Resumes";
import Apply from "./Apply";
import Featured from "./FeaturedEmployer";
import HiringEvents from "./HiringEvents";
import Contact from "./Contact";

const Index = () => {
  return (
    <Fragment>
      <Hero />
      <Jobs />
      <Resume />
      <Apply />
      <Featured />
      <HiringEvents />
      <Contact />
    </Fragment>
  );
};

export default Index;
